import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { map } from 'rxjs/operators';

export const canUnAuthenticated: CanActivateFn = () => {
  const router = inject(Router);
  const nbAuthService = inject(NbAuthService);
  return nbAuthService.isAuthenticatedOrRefresh().pipe(
    map((authenticated) => {
      if (authenticated) {
        router
          .navigate(['pages'])
          .catch((error: unknown) => console.error('Redirect to the pages route failed', error));
      }
      return !authenticated;
    }),
  );
};
